import { Injectable } from '@angular/core';
import { EntityService, HttpClient } from '@elotech/angular-common';
import { Observable } from 'rxjs';
import { EsocialErro } from '../components/esocial-error/erro/esocial-erro';

@Injectable()
export class EsocialService<T> extends EntityService<T> {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  public errosEsocialByEntityId(id: number): Observable<EsocialErro[]> {
    return this.httpClient.get({
      resource: `${this.resource}/erros-esocial/${id}`
    });
  }

}
